import React from "react";
import URL from "../../../../constant/URL";
import http from "../../../../http/http";
import { withRouter } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Moment from 'react-moment';
import useLearningData from "../../../../hooks/useLearningData";
import { TYPE } from "../../../../constant";
import { useLearningBtn, useLearningHistory, useUserInfo, useWorksheet } from "../../../../hooks";
import A from "../../../common/A";
import { setSoundAction } from "../../../../redux/sound";
import { useDispatch, useSelector } from "react-redux";
import { setAnsweringQuestionsAction } from "../../../../redux/answeringQuestions/answeringQuestions";

const TabComplete = withRouter((props) => {

  const { t, i18n } = useTranslation();
  const { info } = useUserInfo();
  const { setLearningData } = useLearningData();
  const { learningHistoryInfo } = useLearningHistory();
  const [completeList, setCompleteList] = React.useState([]);
  const { handleWorkSheet } = useWorksheet()
  const [goLearning] = useLearningBtn();

  const dispatch = useDispatch();
  const setAnsweringQuestions = payload => { dispatch( setAnsweringQuestionsAction( payload ) ) };

  const moveResultPage = (stgCd) => {
    setLearningData({ stgCd, prevPage: 'courseComplete' });
    props.history.push({
      pathname: URL.LEARNING.RESULT,
      state : {
        stgCd: stgCd,
        entryType: 'courseLearning/list/tab2',
        lrnEntyScnCd: TYPE.LEARNING.COURSE,
      }
    });
  };

  const moveResumePage = (stgCd, resumeYn) => {
    setSoundAction({src : `${ process.env.PUBLIC_URL }/static/audio/common_button.ogg`});
    setLearningData({ stgCd });
    setAnsweringQuestions( { isResumeYn : resumeYn && resumeYn === 'Y' } )

    setTimeout(() => {
      goLearning({
        stage: stgCd,
        lrnEntyScnCd: TYPE.LEARNING.COURSE,
        resumeYn : resumeYn
      });
    }, 0);
  }

  const setStatusColor = (status) => {

    let color = '';

      if(status === 'LPSC02'){
        color = "yellow";
      }else if(status === 'LPSC03'){
        color = "green";
      }else if(status === 'LPSC04'){
        color = "purple";
      }else{
        color = "red";
      }
      return color;
  };

  const renderCompleteList = () => {

    let render;

    if(completeList.length > 0){
      render = completeList.map((item, index)=> {
          return item?.resumeYn === 'Y' ? (
            <article className={`${setStatusColor(item.lrnPrgsStsCd)} comp_lst br_on`} key={index}>
              <div className="head_wrap">
                <div className="num">{item?.rowNum}</div>
                <div className="tit">{item?.stgNm}</div>
                <div className="state">
                  <div className="left">
                    <Moment format="YYYY.MM.DD">
                      {item?.lrnEndDt}
                    </Moment>
                  </div>
                  <div className="right">
                    {
                      i18n.language === 'ko' 
                        ? <span>{item?.lrnPrgsStsCdNm}</span>
                        : ""
                    }
                    
                  </div>
                </div>
              </div>
              
              <div className="con_wrap">
                <p className="txt" dangerouslySetInnerHTML={{ __html: t("LC_03_02.msg013") }}/>
                <div className="btn_wrap two">
                    <A className="btn btn_ag" onClick={(e)=>{
                      e.stopPropagation();
                      moveResumePage(item?.stgCd);
                    }}>{t("LC_03_02.msg011")}</A>
                    <A className="btn btn_go re" onClick={(e)=>{
                      e.stopPropagation();
                      moveResumePage(item?.stgCd, item?.resumeYn);
                    }}>{t("LC_03_02.msg012")}</A>
                </div>
                {/* {
                  (info.channelCode === TYPE.CHANNEL.GLOBAL01 && item.workSheetYn === 'Y') && (
                    <div className="wsDwon_wrap">
                      <A onClick={() => handleWorkSheet(item)}>
                      <button type="button">{t("LC_05_07_01.msg023")}</button>
                      </A>
                    </div>
                  )
                } */}
              </div>
            </article>
          ) : <article className={setStatusColor(item.lrnPrgsStsCd)} key={index} onClick={(e)=>{
            e.stopPropagation();
            moveResultPage(item?.stgCd);
          }}>
            <div className="head_wrap">
              <div className="num">{item?.rowNum}</div>
              <div className="tit">{item?.stgNm}</div>
              <div className="state">
                <div className="left">
                  <Moment format="YYYY.MM.DD">
                    {item?.lrnEndDt}
                  </Moment>
                </div>
                <div className="right">
                  {
                    i18n.language === 'ko' 
                      ? <span>{item?.lrnPrgsStsCdNm}</span>
                      : ""
                  }
                  
                </div>
              </div>
            </div>
          </article>
      });
      
    }else{
      render = <div className="empty">
        <div className="txt">{t("LC_03_02.msg010")}</div>
                </div>
    }


    return render;
  };

  const getCompleteList = () => {

    if (learningHistoryInfo.isCompleteAIDiagnosis === 'N'
      || learningHistoryInfo.isCheckAIDiagnosisResult === 'N'
    ) {
     return;
    }

    http.request({
      url: `${URL.API.LEARNING.COURSE}/end/channel/${info.channelCode}/language/KO/member/${info.learnerId}`,
      success: (res) => {
        setCompleteList(res);
        
        if(res.length > 0) {
          const found = res.find(element => element.resumeYn === 'Y');
          if(found) props.onChangeTab('tab2', null);
        }
      }
    });
  };

  React.useEffect(getCompleteList, []);

  return (
    <>
    {renderCompleteList()}
    </>
  );

});

export default TabComplete;

